import React from 'react';
import { Link } from 'react-router-dom';

import { IconWarningSign } from '@trqk/components';
import { formatDollarsStandard, locale } from '@trqk/utils';

import { FULL_PATHS, HASHES } from '../../../../../../constants';

interface QRROverageMessageProps {
    filename: string;
    qrrCapacity: number;
    qrrOverage: number;
}

export const QRROverageMessage = ({
    filename,
    qrrCapacity,
    qrrOverage,
}: QRROverageMessageProps): JSX.Element => (
    <div
        className="grid"
        style={{
            gridTemplateColumns: '30px auto',
        }}
    >
        <IconWarningSign fillColor="quinary-500" width={20} />
        <p className="text-sm">
            {
                locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.QRR_OVERAGE
                    .YOUR_RECENT_UPLOAD
            }{' '}
            <span className="font-bold">{filename}</span>{' '}
            {`${
                locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.QRR_OVERAGE
                    .EXCEEDED_CAPACITY_OF
            } ${formatDollarsStandard(qrrCapacity)} ${
                locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.QRR_OVERAGE
                    .BY_A_MARGIN_OF
            } ${formatDollarsStandard(qrrOverage)}.`}{' '}
            {
                locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.QRR_OVERAGE
                    .SEE_MORE_DETAILS
            }{' '}
            <Link
                to={({ search }) => ({
                    hash: HASHES.MANAGE_STATEMENTS.ALERTS,
                    pathname: FULL_PATHS.MANAGE_STATEMENTS_CHARTS,
                    search,
                })}
                className="underline"
            >
                {
                    locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.QRR_OVERAGE
                        .ALERTS_TAB
                }
            </Link>{' '}
            {
                locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.QRR_OVERAGE
                    .OF_THE_STATEMENT_MANAGER
            }
        </p>
        <div />
        <p className="mt-2 text-sm font-semibold text-primary-500">
            {
                locale.enUS.ACCOUNT.SECTIONS.PAYMENT_PLAN.QRR_OVERAGE
                    .INCREASE_CAPACITY_HERE
            }
        </p>
    </div>
);
